import { createSelector } from "reselect";

export const selectUser = (state) => state.user;

export const selectOperator = (state) => state.operator;

export const selectUserFullName = createSelector(
  [selectUser, selectOperator],
  (user, operator) => {
    const { first_name: firstName, last_name: lastName, surname } = user;

    return operator ? operator.name : [firstName, lastName, surname].join(" ");
  }
);
